module.exports = __webpack_public_path__ + "estonia.svg?bd34935d8d1b002a2de012042b31eb4a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/estonia.svg
// module id = 160
// module chunks = 10